import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import axios from "axios";
import {gstAddApi} from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";

const GstAdd = () => {
  const [Gst, setGst] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cartUpdated, setGstUpdated] = useState(false);
  const [formData, setFormData] = useState({ gstPercent: "" });
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.gstPercent) {
      toast.error("GST Percentage is required!");
      return;
    }

    try {
      const response = await gstAddApi(formData,token);
      console.log("GST Added Response:", response);

      if (response.status === 200) {
        toast.success("GST added successfully!");
        setFormData({ gstPercent: "" });
      } else {
        toast.error(response.data.errors?.message || "Failed to add GST.");
      }
    } catch (error) {
      console.error("Error adding GST:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  //   useEffect(() => {
  //     const fetchGstList = async () => {
  //       try {
  //         const response = await GstList();
  //         console.log("Gst list:", response);
  //         setGst(response);
  //       } catch (error) {
  //         console.error("Error updating profile:", error);
  //       }
  //     };

  //     fetchGstList();
  //   }, [cartUpdated]);

  //   const handleAddRole=(id)=>{
  //     console.log("Id : ",id)
  //     navigate('/Gst-allocation',{state:{GstSelectId: id,}})
  //   }

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Gsts</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Gsts
                  </li>
                </ol>
              </div>
              <ul className="nav nav-tabs page-header-tab">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#Student-all"
                  >
                    List View
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#Student-profile"
                  >
                    Profile
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#Student-add">
                    Add
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Student-all">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Roll No."
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Department"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            data-provide="datepicker"
                            data-date-autoclose="true"
                            className="form-control"
                            placeholder="Admission Date"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <a
                          href="javascript:void(0);"
                          className="btn btn-sm btn-primary btn-block"
                          title
                        >
                          Search
                        </a>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-6 mt-2">
                        <div className="input-group">
                          <select className="form-control">
                            <option value="">Select Manager Gst</option>
                            <option value="doctor">Doctor</option>
                            <option value="employee">Employee</option>
                            <option value="patient">Patient</option>
                            <option value="agent">Agent</option>
                            <option value="softowner">Softowner</option>
                            <option value="hospital">Hospital</option>
                            <option value="randson_store_owner">
                              Randson Store Owner
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive card">
                  {/* <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th />
                        <th>Gender</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>State</th>
                        <th>Role</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Gst?.map((Gst) => (
                        <tr key={Gst?.id}>
                          <td>{Gst?.id}</td>
                          <td className="w60">
                            <img
                              className="avatar"
                              src="../assets/images/xs/avatar1.jpg"
                              alt=""
                            />
                          </td>
                          <td>
                            <span className="font-16">{`${Gst?.firstName} ${Gst?.lastName}`}</span>
                          </td>
                          <td>{Gst?.gender}</td>
                          <td>{Gst?.email}</td>
                          <td>{Gst?.primaryNumber}</td>
                          <td>{Gst?.state}</td>
                          <td>
                            <button onClick={()=>handleAddRole(Gst.id)} className="btn btn-primary">Add</button>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                            >
                              <i className="fa fa-eye" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="Edit"
                            >
                              <i className="fa fa-edit" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm js-sweetalert"
                              title="Delete"
                              data-type="confirm"
                            >
                              <i className="fa fa-trash-o text-danger" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table> */}
                </div>
              </div>
              <div className="tab-pane" id="Student-profile">
                <div className="row">
                  <div className="col-xl-4 col-md-12">
                    <div className="card">
                      <div className="card-body w_Gst">
                        <div className="Gst_avtar">
                          <img
                            className="rounded-circle"
                            src="../assets/images/sm/avatar2.jpg"
                            alt
                          />
                        </div>
                        <div className="wid-u-info">
                          <h5>Dessie Parks</h5>
                          <p className="text-muted m-b-0">
                            119 Peepee Way, Hilo, HI, 96720
                          </p>
                          <ul className="list-unstyled">
                            <li>
                              <h5 className="mb-0">270</h5>
                              <small>Followers</small>
                            </li>
                            <li>
                              <h5 className="mb-0">310</h5>
                              <small>Following</small>
                            </li>
                            <li>
                              <h5 className="mb-0">908</h5>
                              <small>Liks</small>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">About Me</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <p>
                          Hello I am Celena Anderson a Clerk in Xyz College USA.
                          I love to work with all my college staff and seniour
                          professors.
                        </p>
                        <ul className="list-group">
                          <li className="list-group-item">
                            <b>Gender </b>
                            <div className="pull-right">Female</div>
                          </li>
                          <li className="list-group-item">
                            <b>Department</b>
                            <div className="pull-right">Mechanical</div>
                          </li>
                          <li className="list-group-item">
                            <b>Email </b>
                            <div className="pull-right">test@example.com</div>
                          </li>
                          <li className="list-group-item">
                            <b>Phone</b>
                            <div className="pull-right">1234567890</div>
                          </li>
                          <li className="list-group-item">
                            <div className="clearfix">
                              <div className="float-left">
                                <strong>Study</strong>
                              </div>
                              <div className="float-right">
                                <small className="text-muted">35%</small>
                              </div>
                            </div>
                            <div className="progress progress-xxs">
                              <div
                                className="progress-bar bg-pink"
                                role="progressbar"
                                style={{ width: "35%" }}
                                aria-valuenow={35}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                          </li>
                          <li className="list-group-item">
                            <div className="clearfix">
                              <div className="float-left">
                                <strong>Cricket</strong>
                              </div>
                              <div className="float-right">
                                <small className="text-muted">72%</small>
                              </div>
                            </div>
                            <div className="progress progress-xxs">
                              <div
                                className="progress-bar bg-blue"
                                role="progressbar"
                                style={{ width: "72%" }}
                                aria-valuenow={72}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                          </li>
                          <li className="list-group-item">
                            <div className="clearfix">
                              <div className="float-left">
                                <strong>Music</strong>
                              </div>
                              <div className="float-right">
                                <small className="text-muted">60%</small>
                              </div>
                            </div>
                            <div className="progress progress-xxs">
                              <div
                                className="progress-bar bg-green"
                                role="progressbar"
                                style={{ width: "60%" }}
                                aria-valuenow={60}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="card-footer text-center">
                        <div className="row">
                          <div className="col-md-4 col-sm-4 col-6">
                            <div className="font-18 font-weight-bold">37</div>
                            <div>Projects</div>
                          </div>
                          <div className="col-md-4 col-sm-4 col-6">
                            <div className="font-18 font-weight-bold">51</div>
                            <div>Tasks</div>
                          </div>
                          <div className="col-md-4 col-sm-4 col-6">
                            <div className="font-18 font-weight-bold">61</div>
                            <div>Uploads</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-8 col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Timeline Activity</h3>
                        <div className="card-options">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-fullscreen"
                            data-toggle="card-fullscreen"
                          >
                            <i className="fe fe-maximize" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                          <div className="item-action dropdown ml-2">
                            <a href="javascript:void(0)" data-toggle="dropdown">
                              <i className="fe fe-more-vertical" />
                            </a>
                            <div className="dropdown-menu dropdown-menu-right">
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-eye" /> View
                                Details{" "}
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-share-alt" />{" "}
                                Share{" "}
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-cloud-download" />{" "}
                                Download
                              </a>
                              <div className="dropdown-divider" />
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-copy" /> Copy
                                to
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-folder" />{" "}
                                Move to
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-edit" />{" "}
                                Rename
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-trash" />{" "}
                                Delete
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="summernote">
                          Hello there,
                          <br />
                          <p>
                            The toolbar can be customized and it also supports
                            various callbacks such as <code>oninit</code>,{" "}
                            <code>onfocus</code>, <code>onpaste</code> and many
                            more.
                          </p>
                          <p>
                            Please try <b>paste some texts</b> here
                          </p>
                        </div>
                        <div className="timeline_item ">
                          <img
                            className="tl_avatar"
                            src="../assets/images/xs/avatar1.jpg"
                            alt
                          />
                          <span>
                            <a href="javascript:void(0);">Elisse Joson</a> San
                            Francisco, CA{" "}
                            <small className="float-right text-right">
                              20-April-2024 - Today
                            </small>
                          </span>
                          <h6 className="font600">
                            Hello, 'Im a single div responsive timeline without
                            media Queries!
                          </h6>
                          <div className="msg">
                            <p>
                              I'm speaking with myself, number one, because I
                              have a very good brain and I've said a lot of
                              things. I write the best placeholder text, and I'm
                              the biggest developer on the web card she has is
                              the Lorem card.
                            </p>
                            <a
                              href="javascript:void(0);"
                              className="mr-20 text-muted"
                            >
                              <i className="fa fa-heart text-pink" /> 12 Love
                            </a>
                            <a
                              className="text-muted"
                              role="button"
                              data-toggle="collapse"
                              href="#collapseExample"
                              aria-expanded="false"
                              aria-controls="collapseExample"
                            >
                              <i className="fa fa-comments" /> 1 Comment
                            </a>
                            <div
                              className="collapse p-4 section-gray mt-2"
                              id="collapseExample"
                            >
                              <form className="well">
                                <div className="form-group">
                                  <textarea
                                    rows={2}
                                    className="form-control no-resize"
                                    placeholder="Enter here for tweet..."
                                    defaultValue={""}
                                  />
                                </div>
                                <button className="btn btn-primary">
                                  Submit
                                </button>
                              </form>
                              <ul className="recent_comments list-unstyled mt-4 mb-0">
                                <li>
                                  <div className="avatar_img">
                                    <img
                                      className="rounded img-fluid"
                                      src="../assets/images/xs/avatar4.jpg"
                                      alt
                                    />
                                  </div>
                                  <div className="comment_body">
                                    <h6>
                                      Donald Gardner{" "}
                                      <small className="float-right font-14">
                                        Just now
                                      </small>
                                    </h6>
                                    <p>
                                      Lorem ipsum Veniam aliquip culpa laboris
                                      minim tempor
                                    </p>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="timeline_item ">
                          <img
                            className="tl_avatar"
                            src="../assets/images/xs/avatar4.jpg"
                            alt
                          />
                          <span>
                            <a href="javascript:void(0);" title>
                              Dessie Parks
                            </a>{" "}
                            Oakland, CA{" "}
                            <small className="float-right text-right">
                              19-April-2024 - Yesterday
                            </small>
                          </span>
                          <h6 className="font600">
                            Oeehhh, that's awesome.. Me too!
                          </h6>
                          <div className="msg">
                            <p>
                              I'm speaking with myself, number one, because I
                              have a very good brain and I've said a lot of
                              things. on the web by far... While that's mock-ups
                              and this is politics, are they really so
                              different? I think the only card she has is the
                              Lorem card.
                            </p>
                            <div className="timeline_img mb-20">
                              <img
                                className="width100"
                                src="../assets/images/gallery/1.jpg"
                                alt="Awesome Image"
                              />
                              <img
                                className="width100"
                                src="../assets/images/gallery/2.jpg"
                                alt="Awesome Image"
                              />
                            </div>
                            <a
                              href="javascript:void(0);"
                              className="mr-20 text-muted"
                            >
                              <i className="fa fa-heart text-pink" /> 23 Love
                            </a>
                            <a
                              className="text-muted"
                              role="button"
                              data-toggle="collapse"
                              href="#collapseExample1"
                              aria-expanded="false"
                              aria-controls="collapseExample1"
                            >
                              <i className="fa fa-comments" /> 2 Comment
                            </a>
                            <div
                              className="collapse p-4 section-gray mt-2"
                              id="collapseExample1"
                            >
                              <form className="well">
                                <div className="form-group">
                                  <textarea
                                    rows={2}
                                    className="form-control no-resize"
                                    placeholder="Enter here for tweet..."
                                    defaultValue={""}
                                  />
                                </div>
                                <button className="btn btn-primary">
                                  Submit
                                </button>
                              </form>
                              <ul className="recent_comments list-unstyled mt-4 mb-0">
                                <li>
                                  <div className="avatar_img">
                                    <img
                                      className="rounded img-fluid"
                                      src="../assets/images/xs/avatar4.jpg"
                                      alt
                                    />
                                  </div>
                                  <div className="comment_body">
                                    <h6>
                                      Donald Gardner{" "}
                                      <small className="float-right font-14">
                                        Just now
                                      </small>
                                    </h6>
                                    <p>
                                      Lorem ipsum Veniam aliquip culpa laboris
                                      minim tempor
                                    </p>
                                    <div className="timeline_img mb-20">
                                      <img
                                        className="width150"
                                        src="../assets/images/gallery/7.jpg"
                                        alt="Awesome Image"
                                      />
                                      <img
                                        className="width150"
                                        src="../assets/images/gallery/8.jpg"
                                        alt="Awesome Image"
                                      />
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="avatar_img">
                                    <img
                                      className="rounded img-fluid"
                                      src="../assets/images/xs/avatar3.jpg"
                                      alt
                                    />
                                  </div>
                                  <div className="comment_body">
                                    <h6>
                                      Dessie Parks{" "}
                                      <small className="float-right font-14">
                                        1min ago
                                      </small>
                                    </h6>
                                    <p>
                                      It is a long established fact that a
                                      reader will be distracted by the readable
                                      content of a page when looking
                                    </p>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="timeline_item ">
                          <img
                            className="tl_avatar"
                            src="../assets/images/xs/avatar7.jpg"
                            alt
                          />
                          <span>
                            <a href="javascript:void(0);" title>
                              Rochelle Barton
                            </a>{" "}
                            San Francisco, CA{" "}
                            <small className="float-right text-right">
                              12-April-2024
                            </small>
                          </span>
                          <h6 className="font600">
                            An Engineer Explains Why You Should Always Order the
                            Larger Pizza
                          </h6>
                          <div className="msg">
                            <p>
                              I'm speaking with myself, number one, because I
                              have a very good brain and I've said a lot of
                              things. I write the best placeholder text, and I'm
                              the biggest developer on the web by far... While
                              that's mock-ups and this is politics, is the Lorem
                              card.
                            </p>
                            <a
                              href="javascript:void(0);"
                              className="mr-20 text-muted"
                            >
                              <i className="fa fa-heart text-pink" /> 7 Love
                            </a>
                            <a
                              className="text-muted"
                              role="button"
                              data-toggle="collapse"
                              href="#collapseExample2"
                              aria-expanded="false"
                              aria-controls="collapseExample2"
                            >
                              <i className="fa fa-comments" /> 1 Comment
                            </a>
                            <div
                              className="collapse p-4 section-gray mt-2"
                              id="collapseExample2"
                            >
                              <form className="well">
                                <div className="form-group">
                                  <textarea
                                    rows={2}
                                    className="form-control no-resize"
                                    placeholder="Enter here for tweet..."
                                    defaultValue={""}
                                  />
                                </div>
                                <button className="btn btn-primary">
                                  Submit
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="Student-add">
                <div className="row clearfix">
                  <div className=" col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Basic Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <form className="card-body" onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label>GST Percentage</label>
                          <input
                            type="number"
                            name="gstPercent"
                            className="form-control"
                            placeholder="Enter GST %"
                            value={formData.gstPercent}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-sm-12 mt-3">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default GstAdd;
